module.exports.seq = require("./seq");



// WEBPACK FOOTER //
// ./~/biojs-model/src/index.js